import { useEffect, useState, type Dispatch, type SetStateAction } from "react";

// useState that mirrors its value into localStorage, so user preferences
// (selected symbol, chart type, indicators, range) survive reloads.
export function usePersistentState<T>(
  key: string,
  initial: T,
): [T, Dispatch<SetStateAction<T>>] {
  const [state, setState] = useState<T>(() => {
    try {
      const raw = localStorage.getItem(key);
      if (raw !== null) {
        return JSON.parse(raw) as T;
      }
    } catch {
      // Malformed or unavailable storage falls back to the initial value.
    }
    return initial;
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(state));
    } catch {
      // Storage may be unavailable (private mode, quota); ignore.
    }
  }, [key, state]);

  return [state, setState];
}
